<template>
  <div>
    <a-row>
      <g-master name="Resultados Finales"
                :endpoint="master.endpoint"
                :tableSetup="master.tableSetup"
                :modalFieldsSetup="master.modalFieldsSetup"
                :parentData="parentData"
                @action="masterAction"
                modalWidth="100%"
                ref="master"
      >
        <template slot="expandedRowRender" slot-scope="{text}">
          <template v-for="ve in master.valoresExpandidos">
            {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
          </template>
        </template>
        <template slot="masterModal" slot-scope="{record}">
          <a-row :gutter="[16,16]">
            <a-col v-bind="colOptions">
              <a-form-item :label="$t('Resultado final del indicador(%)')">
                <a-input style="width: 100%"
                         v-decorator="['final_result_indicator', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <g-dropdown endpoint="hierarchy_lookup"
                          :label="$t('Resultado Final Obtenido')"
                          :formItemConfig="fiOptions"
                          :decorator="['id_h_final_results_obtained', { rules: [{ required: false }] }]"
                          :params="eva_resultados_finales_obtenidos">
              </g-dropdown>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions"
                           :label="$t('Descripción Cualitativa del Resultado Final')">
                <a-textarea autoSize
                            v-decorator="['qualitative_description_final_result', { rules: [{ required: false, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
            <a-col v-bind="colOptions">
              <a-form-item v-bind="fiOptions" :label="$t('Valor Final Objetivo')">
                <a-input disabled
                         v-decorator="['final_value_objectives', { rules: [{ required: true, message: 'Valor requerido' }] }]"/>
              </a-form-item>
            </a-col>
          </a-row>
          <a-card v-if="verCar">
            <a-alert
              message="Advertencia"
              :description="error"
              type="warning"
              show-icon
            />
          </a-card>
        </template>
      </g-master>
    </a-row>
  </div>
</template>

<script>
  import JsUtils from '@/util/JsUtils'
  import HttpUtil from '@/util/HttpUtil'

  export default {
    props: ['id_objective', 'id_emp'],
    data () {
      return {
        verCar: false,
        error: '',
        eva_resultados_finales_obtenidos: {
          h_lookup_type: 'EVA_RESULTADOS_FINALES_OBTENIDOS'
        },
        selOptions: {
          allowClear: true
        },
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        master: {
          endpoint: 'eva_resultado_final',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Indicador (%)', dataIndex: 'final_result_indicator', align: 'center', sorter: true, width: 150},
              {title: 'Resultados finales obtenidos', dataIndex: 'desc_results_obtained', align: 'center', sorter: true},
              {
                title: 'Descripción Cualitativa del Resultado Final',
                dataIndex: 'qualitative_description_final_result',
                align: 'center',
                sorter: true,
                width: 450
              },
              {title: 'Valor Final del Objetivos', dataIndex: 'final_value_objectives', align: 'center', sorter: true}
            ]
          },
          modalFieldsSetup: [
            {name: 'final_result_indicator'},
            {name: 'id_h_final_results_obtained'},
            {name: 'qualitative_description_final_result'}
          ],
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ]
        }
      }
    },
    mounted () {
      this.httpClient = new HttpUtil()
    },
    methods: {
      masterAction (action) {
        switch (action.action) {
          case 'masterCreate':
            this.verCar = false
            break
          case 'masterEdit':
            this.verCar = false
            break
          case 'fieldsChange':
            if (!JsUtils.isEmpty(action.changedFields) && !JsUtils.isEmpty(action.changedFields.final_result_indicator)) {
              this.final_result_indicator = action.changedFields.final_result_indicator.value
              if (!JsUtils.isEmpty(this.final_result_indicator)) {
                this.calculaResultado(this.final_result_indicator, this.id_objective, this.id_emp)
              }
            }
            break
        }
      },
      calculaResultado (porcentajeFinal, objetivo, empleado) {
        this.httpClient.getInstance().post('eva_resultado_final_calcula_resultado', {
          final_result_indicator: porcentajeFinal,
          id_objective: objetivo,
          id_emp: empleado
        })
          .then((response) => {
            this.$refs.master.modal.form.setFieldsValue({
              final_value_objectives: response.data
            })
          })
          .catch((error) => {
            this.verCar = true
            this.error = this.$getErrorMessage(error, 'No fue posible calcular el valor final del objetivo, contacte al administrador.')
            // Mensajes.error('Error', this.$getErrorMessage(error, 'No fue posible calcular el valor final del objetivo, contacte al administrador.'))
          })
      }
    },
    computed: {
      parentData () {
        return {
          id_objective: this.id_objective,
          id_emp: this.id_emp
        }
      }
    }
  }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Evaluaciones/Complemento/Resultados.vue